import React, {Component} from 'react';
import './WishlistWizard.css';
import PortalScreen from "../PortalScreen";
import axios from 'axios';
import qs from 'qs';
import ProgressIndicator from "../Parts/ProgressIndicator";
import RmButton from "../../Common/RmButton";
import ArrowLink from "../../Common/ArrowLink";
import WishlistOverviewScreen from "./WishlistOverviewScreen";
import {Redirect} from "react-router-dom";
import ErrorMessage from "../../Common/ErrorMessage";
import RmTextareaField from "../../Forms/RmTextareaField";
import RmRadioField from "../../Forms/RmRadioField";
import Slider from "../Slider/Slider";

export default class WishlistWizard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loadingData: false,
            queryParams: null,
            questionId: null,
            redirectTo: null,
            question: null,
            parentQuestion: null,
            parentAnswer: null,
            isSub: false,
            stats: null,
            answer: null,
            response: "",
            errorMessage: null,
            submitting: false,
            saveOk: false
        };

        this.scrollRef = React.createRef();
    }

    componentDidMount() {
        this.loadParentQuestion(this.props, 'default');
    }

    componentWillReceiveProps(nextProps) {
        this.loadParentQuestion(nextProps, 'default');
    }

    getReturnUrl() {
        let returnUrl = "/wensen?test1";

        if (this.currentList === "praktisch") {
            returnUrl = `/praktisch`;
        }

        return returnUrl;
    }

    loadParentQuestion(props, mode) {
        if (this.state.loadingData) {
            return;
        }

        if (!props) {
            props = this.props;
        }

        this.setState({
            loadingData: true
        });

        // Determine list
        let nextList = "wensen";

        if (props.match.path.indexOf('/praktisch') === 0) {
            nextList = "praktisch";
        }

        // Parse query params if we haven't already
        // It's important to only do this once, otherwise we'd get stuck on questions if one was specifically requested
        let queryParams = this.state.queryParams;
        let isInitialLoad = false;

        if (!queryParams) {
            queryParams = qs.parse(props.location.search, {ignoreQueryPrefix: true});
            isInitialLoad = true;

            this.setState({
                queryParams: queryParams,
                niceTitle: WishlistOverviewScreen.NICE_TITLE_MAP[nextList],
            });
        }

        // Generate API target URL based on current parameters
        let doReset = queryParams.reset && queryParams.reset.toString() === "1";

        if (isInitialLoad && doReset) {
            // Hard reset - start wizard from zero and jump to start
            mode = "reset";
        }

        if (queryParams.soft_reset && queryParams.soft_reset.toString() === "1") {
            // Soft reset - progress through wizard as if it's the first time, but don't jump to start
            doReset = true;
        }

        let questionId = this.state.questionId || parseInt(queryParams.vraag, 10) || 0;
        let apiUrl = `/wishlist/wizard?mode=${mode || "default"}&lijst=${nextList}&vraag=${questionId}&reset=${doReset ? 1 : 0}`;

        this.currentList = nextList;

        this.scrollRef = React.createRef();

        axios.get(apiUrl)
            .then((res) => {
                let data = res.data;

                if (data.ok && data.question) {
                    this.setState({
                        question: data.question,
                        parentQuestion: data.parent_question || data.question,
                        parentAnswer: data.parent_answer || null,
                        stats: data.stats,
                        answer: data.answer,
                        questionId: data.question.id,
                        response: (data.answer && data.answer.response_text) || "",
                        errorMessage: null,
                        isSub: data.parent_question && data.parent_question.id !== data.question.id
                    });
                } else {
                    throw new Error('Bad response or out of questions');
                }
            })
            .catch((err) => {
                console.error('Wishlist wizard GET failure', err);

                this.setState({
                    redirectTo: this.getReturnUrl()
                });
            })
            .then(() => {
                this.setState({
                    loadingData: false
                });

                setTimeout(() => {
                    if (this.scrollRef && this.scrollRef.current) {
                        this.scrollRef.current.scrollIntoView({behavior: 'smooth'});
                    }
                }, 500);
            });
    }

    handleSkipClick() {
        if (this.state.submitting || this.state.loadingData) {
            return;
        }

        this.loadParentQuestion(this.props, 'next');
    }

    handleBackClick() {
        if (this.state.submitting || this.state.loadingData) {
            return;
        }

        this.loadParentQuestion(this.props, 'prev');
    }

    handleResponseChange(nextValue) {
        this.setState({
            response: nextValue,
            errorMessage: null,
            saveOk: false
        });
    }

    handleSaveClick() {
        if (this.state.submitting || this.state.loadingData) {
            return;
        }

        if (!this.state.response) {
            this.setState({
                errorMessage: "Vul een antwoord in, of sla de vraag over."
            });

            return;
        }

        this.setState({
            submitting: true,
            errorMessage: null,
            saveOk: false
        });

        let payload = {
            question_id: this.state.questionId,
            response: this.state.response
        };

        axios.post('/wishlist/wizard', payload)
            .then((res) => {
                if (res.data.ok) {
                    this.loadParentQuestion(this.props, 'next');

                    this.setState({
                        saveOk: true
                    });
                } else {
                    this.setState({
                        errorMessage: res.data.message || "Antwoord kon niet opgeslagen worden."
                    });
                }
            })
            .catch((err) => {
                console.error('Wizard save POST failed', err);

                this.setState({
                    errorMessage: "Antwoord kon niet opgeslagen worden."
                });
            })
            .then(() => {
                this.setState({
                    submitting: false
                });
            });
    }

    handleParentAnswerClick() {
        if (this.state.submitting || this.state.loadingData) {
            return;
        }

        this.setState({
            question: this.state.parentQuestion,
            parentQuestion: this.state.parentQuestion,
            parentAnswer: null,
            stats: this.state.stats,
            answer: this.state.parentAnswer,
            questionId: this.state.parentQuestion.id,
            response: (this.state.parentAnswer && this.state.parentAnswer.response_text) || "",
            errorMessage: null,
            isSub: false,
            saveOk: false
        });
    }

    renderSlideshow(images) {
        if (!images || !images.length) {
            return (null);
        }

        return <Slider images={images}/>;
    }

    render() {
        if (this.state.redirectTo) {
            return <Redirect to={this.state.redirectTo}/>;
        }

        let busy = this.state.loadingData || this.state.submitting;

        let options = { };

        if (this.state.question && this.state.question.option_labels) {
            for (let i = 0; i < this.state.question.option_labels.length; i++) {
                let _opt = this.state.question.option_labels[i];
                options[_opt] = _opt;
            }
        }

        return (
            <PortalScreen tab={this.currentList} title={"Lijst invullen"} isLoading={busy}
                          subText={"Vul hier stapsgewijs de " + (this.state.niceTitle ? this.state.niceTitle.toLowerCase() : "lijst") + " in."}>
                {this.state.question && (
                    <div className={"WishlistWizard"}>
                        <div className={"WishlistWizard__wrap"}>

                            {this.state.stats &&
                            (
                                <div className={"WishlistOverviewScreen__status WishlistOverviewScreen__status--wizard"}>
                                    <h2 className={"WishlistOverviewScreen__status-title"}>{this.state.niceTitle}</h2>
                                    <p>{this.state.stats.qualifying_answered} van {this.state.stats.qualifying} vragen beantwoord</p>

                                    <div className={"WishlistOverviewScreen__status-bar"}>
                                        <ProgressIndicator value={this.state.stats.q_percentage}/>
                                    </div>
                                </div>
                            )}

                            {this.state.saveOk &&
                                <div className={"WishlistWizard__saved"}>
                                    <i className={"mdi mdi-check-circle"}/>
                                    <span>Je antwoord is opgeslagen.</span>
                                </div>
                            }

                            <div className={"WishlistWizard__box"}>
                                <p className={"WishlistWizard__question-title"}>
                                    <strong>{this.state.parentQuestion.question_number}. {this.state.parentQuestion.question_title}</strong>
                                </p>

                                <div className={"WishlistWizard__question-tips"}>
                                    <p dangerouslySetInnerHTML={{__html: this.state.parentQuestion.advice_html}}/>
                                </div>

                                {this.state.parentQuestion.images && this.state.parentQuestion.images.length > 0 &&
                                    <div className={"WishlistWizard__question-slides"}>
                                        {this.renderSlideshow(this.state.parentQuestion.images)}
                                    </div>
                                }

                                {this.state.isSub && this.state.parentAnswer && this.state.parentAnswer.response_text &&
                                <div className={"WishlistWizard__question-parent-response"}
                                     title={"Klik hier om het gekozen antwoord te wijzigen"}
                                     onClick={this.handleParentAnswerClick.bind(this)}
                                >
                                    <span>Gekozen antwoord:</span>
                                    {this.state.parentAnswer.response_text}
                                </div>
                                }

                                {this.state.isSub &&
                                <p className={"WishlistWizard__question-title WishlistWizard__question-title--sub"} ref={this.scrollRef}>
                                    <strong>{this.state.question.question_number}. {this.state.question.question_title}</strong>
                                </p>
                                }

                                {this.state.isSub && this.state.question.advice_html &&
                                <div className={"WishlistWizard__question-tips WishlistWizard__question-tips--sub"}>
                                    <p dangerouslySetInnerHTML={{__html: this.state.question.advice_html}}/>
                                </div>
                                }

                                {this.state.isSub && this.state.question.images && this.state.question.images.length > 0 &&
                                <div className={"WishlistWizard__question-slides"}>
                                    {this.renderSlideshow(this.state.question.images)}
                                </div>
                                }

                                {this.state.question && this.state.question.question_type === WishlistWizard.Q_TYPE_OPEN &&
                                <div className={"WishlistWizard__question-response"}>
                                    <RmTextareaField id={"response"} label={"Vul een antwoord in..."} disabled={busy}
                                                     onChange={this.handleResponseChange.bind(this)}
                                                     key={`q${this.state.question.id}`}
                                                     value={this.state.response} useTinymce={true}
                                    />
                                </div>
                                }

                                {this.state.question && this.state.question.question_type === WishlistWizard.Q_TYPE_CHOICE &&
                                <div className={"WishlistWizard__question-response"}>
                                    <RmRadioField id={"response"} label={"Kies een antwoord:"}
                                                  options={options}
                                                  onChange={this.handleResponseChange.bind(this)}
                                                  value={this.state.response}
                                    />
                                </div>
                                }

                                <div className={"WishlistWizard__save"}>
                                    {this.state.errorMessage && <ErrorMessage message={this.state.errorMessage}/>}
                                    <RmButton busy={busy} className={"WishlistWizard__save-btn"}
                                              label={"Doorgaan"} onClick={this.handleSaveClick.bind(this)}/>
                                </div>
                            </div>

                            <div className={"WishlistWizard__bottom-links"}>
                                <ArrowLink label={"Ga een stap terug"} onClick={this.handleBackClick.bind(this)} reverse={true}/>
                                <div className={"WishlistWizard__bottom-links-spacer"}>•</div>
                                <ArrowLink label={"Sla deze vraag over"} onClick={this.handleSkipClick.bind(this)}/>
                            </div>
                        </div>
                    </div>
                )}
            </PortalScreen>
        );
    }
}

WishlistWizard.Q_TYPE_OPEN = 0;
WishlistWizard.Q_TYPE_CHOICE = 1;



// WEBPACK FOOTER //
// ./src/Portal/Wishlist/WishlistWizard.js